<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref=""></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span translate>Event log</span>
    </ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="showMenu($event)">
        <ion-icon slot="icon-only" name="ellipsis-vertical-sharp"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let record of logger.records">
      <ion-icon slot="start" [name]="icons[record.level]?.name" [ngStyle]="icons[record.level]?.style"></ion-icon>
      <ion-label class="ion-text-wrap">
        <span slot="start">{{record.time | date:'HH:mm:ss'}}.{{(record.time % 1000) | number:'3.0-0'}}:</span>
        <span *ngFor="let arg of record.args"> {{stringify(arg)}}</span>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
